function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connectTwoFactorAuthentication } from '@/actions/AuthActions';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import { useNavigate } from 'react-router';
import { WebRoutes } from '@/utils/constants';
import { useIntl } from 'react-intl';
import { TwoFactorRequired } from '../twofactor/TwoFactorRequiredModal';
import { Box, Stack } from '@chakra-ui/react';
import { Helmet } from 'react-helmet';
import useHydrated from '@/hooks/useHydrated';
import useLoginRedirect from '@/hooks/useLoginRedirect';
import { useShallow } from 'zustand/react/shallow';
export default function TwoFactor() {
    var intl = useIntl();
    var _useAuthenticationStore = useAuthenticationStore(useShallow(function(state) {
        return {
            accessToken: state.accessToken,
            redirectPath: state.redirectPath,
            unverified2FA: state.unverified2FA,
            setRedirectPath: state.setRedirectPath,
            setAccessToken: state.setAccessToken,
            setUnverified2FA: state.setUnverified2FA
        };
    })), accessToken = _useAuthenticationStore.accessToken, redirectPath = _useAuthenticationStore.redirectPath, unverified2FA = _useAuthenticationStore.unverified2FA, setRedirectPath = _useAuthenticationStore.setRedirectPath, setAccessToken = _useAuthenticationStore.setAccessToken, setUnverified2FA = _useAuthenticationStore.setUnverified2FA;
    var isHydrated = useHydrated(useAuthenticationStore);
    var navigate = useNavigate();
    var redirectLogin = useLoginRedirect(redirectPath);
    React.useEffect(function() {
        if (!isHydrated) {
            return;
        }
        if (unverified2FA && accessToken != null) {
            return;
        }
        redirectLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isHydrated
    ]);
    var handleComplete = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(value) {
            var accessToken;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            connectTwoFactorAuthentication(value, false)
                        ];
                    case 1:
                        accessToken = _state.sent().accessToken;
                        setAccessToken(accessToken);
                        setUnverified2FA(false);
                        setRedirectPath(null);
                        navigate(redirectPath !== null && redirectPath !== void 0 ? redirectPath : WebRoutes.DASHBOARD);
                        return [
                            2
                        ];
                }
            });
        });
        return function(value) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setAccessToken,
        setUnverified2FA,
        navigate,
        setRedirectPath,
        redirectPath
    ]);
    return /*#__PURE__*/ _jsxs(Box, {
        display: "grid",
        placeItems: "center",
        height: "100vh",
        backgroundColor: "backgroundSecondary",
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "AJyYQz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Two-Factor Authentication"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Stack, {
                borderWidth: 1,
                spacing: 0,
                borderColor: "borderSecondary",
                width: "100%",
                maxWidth: "440px",
                margin: "auto",
                borderRadius: "md",
                backgroundColor: "backgroundPrimary",
                children: /*#__PURE__*/ _jsx(TwoFactorRequired, {
                    onComplete: handleComplete,
                    description: intl.formatMessage({
                        id: "0UGoJy",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Enter the code generated by your Authenticator app."
                            }
                        ]
                    }),
                    heading: intl.formatMessage({
                        id: "AJyYQz",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Two-Factor Authentication"
                            }
                        ]
                    })
                })
            })
        ]
    });
}
